import { render, staticRenderFns } from "./TeachingWorkReviewModal.vue?vue&type=template&id=35315c28&scoped=true"
import script from "./TeachingWorkReviewModal.vue?vue&type=script&lang=js"
export * from "./TeachingWorkReviewModal.vue?vue&type=script&lang=js"
import style0 from "./TeachingWorkReviewModal.vue?vue&type=style&index=0&id=35315c28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35315c28",
  null
  
)

export default component.exports